<section class="title-bar content-padding first-item">
  <div class="wrapper">
    <h2 class="left">{{ form?.teamLeader?.id ? "Modifica" : "Nuovo" }} Team Leader</h2>
    <br class="clear">
  </div>
</section>

<app-team-leader-form></app-team-leader-form>
